"use client";

import { useState } from "react";
import { handleMailingList } from "@/app/utils/handle-mailing-list";

function MailingList() {
  const [email, setEmail] = useState("");

  return (
    <div id="mailing-list" className="w-full not-prose my-8">
      <div className="relative w-full rounded-2xl overflow-hidden bg-panel shadow-xl border border-line">
        <div className="absolute top-0 right-0 w-48 h-48 bg-primary/15 rounded-full blur-3xl pointer-events-none" />

        <div className="relative px-8 py-8 flex flex-col sm:flex-row sm:items-center gap-6">
          {/* Text */}
          <div className="flex-1">
            <p className="text-primary font-semibold text-xs uppercase tracking-widest mb-1">Newsletter</p>
            <h2 className="text-white text-lg font-bold leading-snug mb-1">
              Build smarter, ship faster
            </h2>
            <p className="text-zinc-400 text-sm">
              Weekly tips on Chrome extension development, marketing, and monetization.
            </p>
          </div>

          {/* Input + button */}
          <div className="flex flex-col sm:flex-row gap-2 sm:items-center sm:shrink-0">
            <input
              type="email"
              placeholder="you@example.com"
              className="px-4 py-2.5 rounded-xl bg-ink-soft border border-line text-white placeholder-zinc-500 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/30 transition-all duration-200 text-sm w-full sm:w-52"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              className="px-5 py-2.5 bg-primary hover:bg-secondary text-white font-semibold rounded-full ring-1 ring-inset ring-white/15 transition-all duration-200 text-sm whitespace-nowrap"
              onClick={() => handleMailingList("", email)}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MailingList;
